import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-windowed-select'
import ImmutablePropTypes from 'react-immutable-proptypes'

import Button from '../../button'
import Label from '../../form/Label'
import ButtonBar from '../../button/ButtonBar'
import CopaidSessionsBalanceChip from '../../chips/copaidSessionsBalanceChip'
import { renderCheckboxField } from '../../form/utils'
import {
  getCopaidSessionsBalance, getOptimisticCopaidBalance, patientRequiresCopay,
} from '../../../utils/copaySessions'

const PatientSearch = (props) => {
  const { patients } = props

  const getDatasource = () => {
    if (!patients || patients.count() === 0) return []
    return patients.valueSeq().map(patient => ({
      value: patient.get('_id'),
      label: `${patient.get('fullName')} ${patient.get('dni')}`,
    })).toJS()
  }

  const handlePatientSelected = (selected) => {
    const { handleChange } = props
    handleChange(selected)
  }

  const {
    showViewButton, showNewButton, openPatientDialog, openNewPatientDialog, value, defaultValue,
    showCopayBalance, insuranceCompanies, onCopayChipClick, copayConsumed, onCopayConsumedChange,
    savedCopayConsumed, isClearable,
  } = props
  const selectedOption = value || defaultValue
  const selectedPatientId = selectedOption && selectedOption.value
  const selectedPatient = selectedPatientId && patients ? patients.get(selectedPatientId) : null
  const copayBalance = selectedPatient
    ? (savedCopayConsumed !== undefined
      ? getOptimisticCopaidBalance(selectedPatient, {
        savedCopayConsumed,
        currentCopayConsumed: !!copayConsumed,
      })
      : getCopaidSessionsBalance(selectedPatient))
    : null
  const shouldShowCopayBalance = showCopayBalance
    && selectedPatient
    && patientRequiresCopay(selectedPatient, insuranceCompanies)

  return (
    <div>
      <Label>Paciente</Label>
      <div className='form-row'>
        <Select
          className='full-width'
          classNamePrefix='select'
          options={getDatasource()}
          defaultValue={defaultValue}
          value={value || defaultValue}
          onChange={handlePatientSelected}
          placeholder='Buscar paciente'
          isClearable={isClearable}
        />
        {(showViewButton || showNewButton) && (
        <ButtonBar>
          {(value || defaultValue) && showViewButton && (
            <Button variant='text' onClick={openPatientDialog}>Ver</Button>
          )}
          {showNewButton && <Button onClick={openNewPatientDialog}>Nuevo</Button>}
        </ButtonBar>
        )}
      </div>
      {shouldShowCopayBalance && (
        <div className='copay-controls-row'>
          <CopaidSessionsBalanceChip
            balance={copayBalance}
            onClick={onCopayChipClick ? () => onCopayChipClick(selectedPatientId) : undefined}
          />
          <div className='form-row' />
          <div className='form-row' />
          {onCopayConsumedChange && renderCheckboxField({
            label: 'Copago Requerido',
            name: 'copayConsumed',
            checked: !!copayConsumed,
            onChange: onCopayConsumedChange,
          })}
        </div>
      )}
    </div>
  )
}

PatientSearch.defaultProps = {
  showViewButton: true,
  showNewButton: true,
  defaultValue: null,
  showCopayBalance: false,
  isClearable: false,
}

PatientSearch.propTypes = {
  patients: ImmutablePropTypes.map,
  insuranceCompanies: ImmutablePropTypes.map,
  handleChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  showViewButton: PropTypes.bool,
  showNewButton: PropTypes.bool,
  showCopayBalance: PropTypes.bool,
  isClearable: PropTypes.bool,
  onCopayChipClick: PropTypes.func,
  copayConsumed: PropTypes.bool,
  savedCopayConsumed: PropTypes.bool,
  onCopayConsumedChange: PropTypes.func,
  openNewPatientDialog: PropTypes.func,
  openPatientDialog: PropTypes.func,
}

export default PatientSearch
